import React, { useState } from 'react';
import { ArrowRightIcon, CheckCircle2Icon } from 'lucide-react';
import { SmartLink } from '../SmartLink';
type ProductCtaProps = {
  headline: string;
  subheadline: string;
};
type Status = 'idle' | 'error' | 'success';
export function ProductCta({
  headline,
  subheadline
}: ProductCtaProps) {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<Status>('idle');
  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
    setStatus(valid ? 'success' : 'error');
  };
  return <section id="get-started" data-nav-theme="dark" className="footer-gradient w-full py-20" aria-labelledby="cta-heading" data-id="element-1161" data-mp="2nhx8vn7o93p0">
      <div className="mx-auto max-w-shell px-6 text-center" data-id="element-1162" data-mp="2sf5rfowqf9qs">
        <h2 id="cta-heading" className="display mx-auto max-w-[640px] text-[32px] font-semibold text-white sm:text-[44px]" data-id="element-1163" data-mp="3g6b5byj43ryg">
          {headline}
        </h2>
        <p className="mx-auto mt-5 max-w-[480px] text-[16px] leading-[1.55] text-white/70" data-id="element-1164" data-mp="pj7ivyz7ffpi">{subheadline}</p>

        {status === 'success' ? <p className="mx-auto mt-9 inline-flex items-center gap-2 rounded-[10px] bg-white/10 px-5 py-3.5 text-[15px] font-medium text-white" data-id="element-1165" data-mp="kl63pp4wg0jb">
            <CheckCircle2Icon className="h-5 w-5 text-[#6FD08C]" aria-hidden="true" data-id="element-1166" data-mp="zau48o59av5z" />
            Thanks — we’ll email you a link to set up your account.
          </p> : <form onSubmit={onSubmit} noValidate className="mx-auto mt-9 flex w-full max-w-[440px] flex-col gap-2 sm:flex-row sm:items-center sm:gap-0 sm:rounded-[10px] sm:bg-white sm:p-1.5" data-id="element-1167" data-mp="187uoqjp7g945">
            <label htmlFor="cta-email" className="sr-only" data-id="element-1168" data-mp="1d91wiircl8at">
              Work email
            </label>
            <input id="cta-email" type="email" value={email} onChange={e => {
          setEmail(e.target.value);
          if (status === 'error') setStatus('idle');
        }} placeholder="Enter your work email" aria-invalid={status === 'error'} aria-describedby={status === 'error' ? 'cta-email-error' : undefined} className="min-w-0 flex-1 rounded-[10px] bg-white px-4 py-3 text-[15px] text-ink outline-none placeholder:text-ink-muted sm:rounded-none sm:bg-transparent sm:px-3 sm:py-2" data-id="element-1169" data-mp="3jyq6l58o12ir" />
            <button type="submit" className="shrink-0 rounded-[7px] bg-brand px-5 py-3 text-[15px] font-semibold text-white transition-colors duration-150 ease-out hover:bg-brand-hover sm:py-2.5" data-id="element-1170" data-mp="rgzg3xok8blw">
              Get started
            </button>
          </form>}
        {status === 'error' && <p id="cta-email-error" className="mt-3 text-[13px] text-[#FF9C8A]" data-id="element-1171" data-mp="1a88r6bdzb8fl">
            Enter a valid email address, like aline@inzozi.rw
          </p>}

        <SmartLink href="/demo" className="mt-6 inline-flex items-center gap-1.5 text-[15px] font-medium text-white/80 transition-colors duration-150 ease-out hover:text-white" data-id="element-1172" data-mp="1f7v5yp9ggwqi">
          Or book a demo
          <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-1173" data-mp="2pr80zg1fsv9q" />
        </SmartLink>
      </div>
    </section>;
}